import { useMemo } from 'react';
import Hero from '@/pages/home/components/Hero';
import HotRanking from '@/pages/home/components/HotRanking';
import TimelineSpotlight from '@/pages/home/components/TimelineSpotlight';
import CategorySection from '@/pages/home/components/CategorySection';
import LatestUpdates from '@/pages/home/components/LatestUpdates';
import Testimonials from '@/pages/home/components/Testimonials';
import FaqPreview from '@/pages/home/components/FaqPreview';
import { useSEO } from '@/hooks/useSEO';
import { faqs } from '@/mocks/faqs';

export default function Home() {
  const jsonLd = useMemo(() => {
    const visibleFaqs = faqs.slice(0, 5);
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '西瓜黑料',
        description:
          '按时间线整理每一段瓜的吃瓜资讯站，覆盖起始、后续瓜、反转、续集、进度与结局。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '西瓜黑料',
        description: '以时间线方式梳理网络热点的吃瓜资讯站。',
        email: 'contact@xigua-heiliao.example.com',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: visibleFaqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: { '@type': 'Answer', text: faq.answer },
        })),
      },
    ];
  }, []);

  useSEO({
    title: '西瓜黑料 — 按时间线追完每一出吃瓜大戏',
    description:
      '西瓜黑料按时间线整理每一段瓜，起始、后续瓜、反转、续集、进度与结局一次看全，像追连续剧一样看完一整出吃瓜大戏。',
    keywords: '西瓜黑料,西瓜黑料时间线,西瓜黑料反转,西瓜黑料后续瓜,西瓜黑料进度,西瓜黑料续集,西瓜黑料结局',
    path: '/',
    jsonLd,
  });

  return (
    <>
      <Hero />
      <HotRanking />
      <TimelineSpotlight />
      <CategorySection />
      <LatestUpdates />
      <Testimonials />
      <FaqPreview />
    </>
  );
}